<div class="picker" [class.static-mode]="staticMode" *ngIf="isOpen" (click)="$event.stopPropagation()">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
    <button 
      type="button" 
      [disabled]="!canGoPrev()" 
      (click)="prevMonth(); $event.stopPropagation()"
      [style.opacity]="canGoPrev() ? '1' : '0.3'"
      [style.cursor]="canGoPrev() ? 'pointer' : 'not-allowed'"
      style="width: 32px; height: 32px; background: transparent; color: #6b7280; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 14px; display: flex; align-items: center; justify-content: center; transition: all 0.2s;"
      onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#3554d1'; this.style.color='#3554d1';"
      onmouseout="this.style.background='transparent'; this.style.borderColor='#e5e7eb'; this.style.color='#6b7280';"
    >‹</button>
    <span style="font-size: 16px; font-weight: 600; color: #111;">{{ getMonthYear() }}</span>
    <button 
      type="button" 
      (click)="nextMonth(); $event.stopPropagation()"
      style="width: 32px; height: 32px; background: transparent; color: #6b7280; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 14px; display: flex; align-items: center; justify-content: center; transition: all 0.2s; cursor: pointer;"
      onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#3554d1'; this.style.color='#3554d1';"
      onmouseout="this.style.background='transparent'; this.style.borderColor='#e5e7eb'; this.style.color='#6b7280';"
    >›</button>
  </div>
  
  <div class="weekdays">
    <span *ngFor="let d of weekDays">{{ d }}</span>
  </div>
  
  <div class="days">
    <button 
      *ngFor="let day of calendarDays; trackBy: trackByDay"
      type="button"
      [class.other]="!day.isCurrentMonth"
      [class.past]="day.isPast"
      [class.today]="day.isToday"
      [class.in-range]="isInRange(day)"
      [class.start]="isStartDay(day)"
      [class.end]="isEndDay(day)"
      [disabled]="day.isPast || !day.isCurrentMonth"
      (click)="onDayClick(day)"
      (mouseenter)="onDayHover(day)"
    >{{ day.dayNumber }}</button>
  </div>
  
  <div class="footer">
    <span class="hint">{{ getHint() }}</span>
    <button type="button" class="clear" (click)="clear()">Temizle</button>
  </div>
</div>
